import React from 'react';
import ReactDOM from 'react-dom';
import TrainerCourseDetail from '../components/TrainerCourseDetail';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally
window.renderTrainerCourseDetail = (elementId, props) => {
    const element = document.getElementById(elementId);
    if (element) {

        initializeI18n()
            .then((i18nInstance) => {
                ReactDOM.render(<TrainerCourseDetail props={props} />, element);
            })
            .catch(error => {
                //console.error("Failed to initialize i18n before rendering TrainerCourseDetail:", error);
            });

    } else {
        //console.error(`Element with ID ${elementId} not found.`);
    }
};